import { constants, visuallyHiddenStyles } from "@newsela/angelou";

export const ctaCopyContainerCss = {
  display: "grid",
  gridTemplateColumns: "1fr auto",
};

export const ctaCopyButtonCss = {
  root: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
};

export const ctaCopyInputCss = {
  input: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    color: constants.colors.ui.neutral[400],
  },
  // hide the label and adjacent (optional) text
  labelText: {
    ...visuallyHiddenStyles,
    "+ div": visuallyHiddenStyles,
  },
};

export const iconCss = {
  "--icon-stroke-width": 3,
};
